import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=4de3e0f8&scoped=true&"
import script from "./orderList.js?vue&type=script&lang=js&"
export * from "./orderList.js?vue&type=script&lang=js&"
import style0 from "./orderList.vue?vue&type=style&index=0&id=4de3e0f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de3e0f8",
  null
  
)

export default component.exports